import React from 'react';
import { useTranslation } from 'react-i18next';
import { Drawer, Steps } from 'antd';
import { useGetCargoItemStatusHistory } from 'api/cargo-items/use-get-cargo-item-status-history.ts';
import { formatDateTime } from 'shared/utils/time/format-date-time.ts';
import { CargoItemStatus } from 'components/cargos/cargo-item-status';

interface ICargoItemStatusHistoryProps {
  cargoItemId: number;
  cargoId: number;
  isOpen: boolean;
  onClose: () => void;
}

export const CargoItemStatusHistory: React.FC<ICargoItemStatusHistoryProps> = (props) => {
  const { cargoItemId, cargoId, isOpen, onClose } = props;
  const { t } = useTranslation();

  const { data: history } = useGetCargoItemStatusHistory({ cargoId, cargoItemId, enabled: isOpen });
  return (
    <Drawer title={t('common:status_history')} placement='right' open={isOpen} onClose={onClose}>
      <Steps
        current={0}
        direction='vertical'
        items={history?.map((status) => ({
          title: <CargoItemStatus type={status.type} from={status.fromWarehouseId} to={status.toWarehouseId} />,
          description: formatDateTime(status.createdAt) + ' • ' + status.user?.name,
        }))}
        progressDot
      />
    </Drawer>
  );
};
